import axios from "@/api/axiosAuthRequired.js"
import { getAuthHeaders } from "./auth"

const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL

export const getCourses = async ({ game, pageNumber }) => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    let url = `${PROGUIDES_WEB_URL}api/v2/courses`
    const config = {
      params: {
        game,
        page: pageNumber,
      },
      headers: { Authorization: "Bearer " + clientCredentials },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return {
      total_count: 0,
      results: [],
    }
  }
}

export const getActiveCourses = async () => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const url = `${PROGUIDES_WEB_URL}api/v2/user/content-progression/courses/active`
    const res = await axios.get(url, {
      headers: { Authorization: "Bearer " + clientCredentials },
    })

    return res.data
  } catch (error) {
    console.error(error)
    return []
  }
}

export const getActiveCourseProgress = async () => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const url = `${PROGUIDES_WEB_URL}api/v2/user/content-progression/courses`
    const res = await axios.get(url, {
      headers: { Authorization: "Bearer " + clientCredentials },
    })
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const trackActiveCourse = async courseId => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/user/content-progression/courses/active`
    await axios.put(url, { course_id: courseId }, config)
  } catch (error) {
    console.error(error)
  }
}

export const untrackActiveCourse = async courseId => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const url = `${PROGUIDES_WEB_URL}api/v2/user/content-progression/courses/active`
    await axios.delete(url, {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
      data: {
        course_id: courseId,
      },
    })
  } catch (error) {
    console.error(error)
  }
}

export const logLessonAttempt = async lessonId => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }
    const body = {
      content_type: "segment",
      content_id: lessonId,
      status: true,
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/user/content-progression/attempt`
    await axios.post(url, body, config)
  } catch (error) {
    console.error(error)
  }
}

export const logLessonCompletion = async lessonId => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }
    const body = {
      content_type: "segment",
      content_id: lessonId,
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/user/content-progression/complete`
    await axios.post(url, body, config)
  } catch (error) {
    if (error.response.status === 403) {
      console.log(error.response.data.message)
    } else {
      console.error(error)
    }
  }
}

export const getCourseById = async courseId => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const url = `${PROGUIDES_WEB_URL}api/v2/courses/${courseId}`
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }
    const data = await axios.get(url, config)
    return data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getCourseByShortcode = async shortcode => {
  try {
    const url = `${PROGUIDES_WEB_URL}api/v2/courses/by-shortcode/${shortcode}`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getChaptersByCourseId = async courseId => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const url = `${PROGUIDES_WEB_URL}api/v2/courses/${courseId}/chapters`
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getLessonById = async (course, chapter, lesson) => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const url = `${PROGUIDES_WEB_URL}api/v2/courses/${course}/chapters/${chapter}/segments/${lesson}`
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const submitLessonRating = async (rating, course, chapter, lesson) => {
  try {
    const url = `${PROGUIDES_WEB_URL}api/v2/courses/${course}/chapters/${chapter}/segments/${lesson}/rate`
    const clientCredentials = localStorage.getItem("client_credentials")
    const data = {
      rating,
    }
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }
    const res = await axios.post(url, data, config)
    return res.status
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getCoursesForCheckout = async () => {
  try {
    let url = `${PROGUIDES_WEB_URL}api/v2/courses/checkout-ordered`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return {
      total_count: 0,
      results: [],
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/course.js